import React from 'react';
import { prepareUrlV2 } from 'utils/Urls';
import { Alert } from '@razorpay/blade/components';
import { routePaths } from 'components/Routes/data';
import { companyOnboardingSteps } from 'components/Routes/data';

export const OrgSettingDisabledAlert = ({
  description,
  linkText,
}: {
  description: string;
  linkText: string;
}) => {
  const complianceSettingsUrl = prepareUrlV2(routePaths.phpRoutes.companyOnboarding, {
    step: companyOnboardingSteps.complianceSettings,
  });

  return (
    <Alert
      description={description}
      color="information"
      isDismissible={false}
      actions={{
        secondary: {
          text: linkText,
          target: '_blank',
          href: complianceSettingsUrl,
        },
      }}
    />
  );
};
